import {dynamic} from '@github-ui/dynamic'
import {useNavigableRef} from '@github-ui/navigable-ref'
import {useCallback, useEffect, useState} from 'react'

import {GlobalNavMenuToggle} from '../menu/GlobalNavMenuToggle'
import {useDeferredPayloadSlice} from '../utils/DeferredNavPayloadContext'

export function LazyAnchoredGlobalNavMenu() {
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const anchorRef = useNavigableRef<HTMLButtonElement>()
  const {data: menuProps, isPending} = useDeferredPayloadSlice('nav_menu')

  useEffect(() => {
    let cancelled = false

    LazyGlobalNavMenu.preload()
      // eslint-disable-next-line github/no-then
      .then(() => {
        if (!cancelled) {
          setIsLoading(false)
        }
      })
      // eslint-disable-next-line github/no-then
      .catch(() => {
        if (!cancelled) {
          setIsLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [])

  const onClose = useCallback(() => {
    setOpen(false)
  }, [setOpen])

  const showLoadingState = isLoading || isPending
  const openMenu = open && !showLoadingState
  return (
    <>
      <GlobalNavMenuToggle ref={anchorRef} setOpen={setOpen} open={open} isLoading={open && showLoadingState} />
      <LazyGlobalNavMenu returnFocusRef={anchorRef} open={openMenu} onClose={onClose} {...menuProps} />
    </>
  )
}

const LazyGlobalNavMenu = dynamic(
  async () => {
    const mod = await import('../menu/GlobalNavMenu')
    return {default: mod.GlobalNavMenu}
  },
  {ssr: false},
)
